// AngularJS text inputs trim their model before applying {$: keyword}.
export function matchesNestedKeyword(value: unknown, keyword: string): boolean {
  const match = (query: string): boolean => {
    if (query.startsWith('!')) return !match(query.slice(1));
    if (!query) return true;
    const contains = (item: unknown): boolean => {
      if (item == null) return false;
      if (Array.isArray(item)) return item.some(contains);
      if (typeof item === 'object') {
        return Object.entries(item).some(([key, nested]) => !key.startsWith('$') && contains(nested));
      }
      return ['string', 'number', 'boolean'].includes(typeof item)
        && String(item).toLowerCase().includes(query);
    };
    return contains(value);
  };
  return match(keyword.trim().toLowerCase());
}
